import {type Draft} from "immer";
import {create as _create, type StateCreator} from "zustand";

type TSetter<S> = (
  updater: S | Partial<S> | ((state: Draft<S>) => void),
  shouldReplace?: boolean,
  action?: string,
) => void;

const resetters: (() => void)[] = [];

const create = (<T extends unknown>(f: StateCreator<T> | undefined) => {
  if (typeof f === "undefined") return create;
  const store = _create(f);
  const initialState = store.getState();
  resetters.push(() => store.setState(initialState, true));
  return store;
}) as typeof _create;

const resetAllStores = () => {
  for (const resetter of resetters) {
    resetter();
  }
};

export {create, resetAllStores, type TSetter};
